export const unsupportedBowsers = [
    {
        name: 'IE',
        version: 11.
    },
];